import React, { useState , useRef , useEffect} from "react";
import useStyles from "./style";
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button, 
  TextField,
  Grid,
  Typography
} from "@mui/material";
import {Close , LocationOn } from  "@mui/icons-material";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { useFormik, useField } from "formik";
import * as yup from "yup";
// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
// Components 
import Estimatedcarousel from "./Estimatedcarousel"
import DistanceAndRate from "./DistanceDuration"
//Services
import HotelApi from "Services/Hotel";

const BookingForm = ({setOrigin , setDestination , origin , destination, setMapCenter , services , timezone , userType}) => {

const classes = useStyles();
const dispatch = useDispatch();
const navigate = useNavigate();
const placesLibrary = useMapsLibrary("places");
const [pickupLatLng, setPickupLatLng] = useState(null);
const [dropLatLng, setDropLatLng] = useState(null);
const [distance, setDistance] = useState(null);
const [duration, setDuration] = useState(null);
const [travelDuration,setTravelduration] = useState('');
const [activeService, setActiveService] = useState(null);
const [pickupInput, setPickupInput] = useState('');
const [pickupSuggestions, setPickupSuggestions] = useState([]);
const [dropInput, setDropInput] = useState('');
const [dropSuggestions, setDropSuggestions] = useState([]);
const autocompleteService = useRef(null);
const placesServiceRef = useRef(null);


useEffect(() => {
if (placesLibrary && !autocompleteService.current) {
  autocompleteService.current = new placesLibrary.AutocompleteService();
}
},[placesLibrary]);

useEffect(() => {
  if (placesLibrary && !placesServiceRef.current && document.getElementById('map-temp')) {
    placesServiceRef.current = new placesLibrary.PlacesService( document.getElementById('map-temp'));
  }
}, [placesLibrary]);

const handlePickupChange = (e) => {
  const value = e.target.value;
  setPickupInput(value);
  if (value.length >= 6 && autocompleteService.current) {
    autocompleteService.current.getPlacePredictions({
      input: value
    }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setPickupSuggestions(predictions);
      } else {
        setPickupSuggestions([]);
      }
    });
  } else {
    setPickupSuggestions([]);
  }
};

const handleDropChange = (e) => {
  const value = e.target.value;
  setDropInput(value);
  if (value.length >= 6 && autocompleteService.current) {
    autocompleteService.current.getPlacePredictions({
      input: value
    }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setDropSuggestions(predictions);
      } else {
        setDropSuggestions([]);
      }
    });
  } else {
    setDropSuggestions([]);
  }
};

const handlePickupSelect = (placeId, description) => {
  placesServiceRef.current.getDetails({ placeId }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setPickupLatLng({ lat, lng });
      setOrigin({ lat, lng }); 
      setPickupInput(description);
      setPickupSuggestions([]);
    }
  });
};

const handleDropSelect = (placeId, description) => {
  placesServiceRef.current.getDetails({ placeId }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setDropLatLng({ lat, lng });
      setDestination({ lat, lng });
      setDropInput(description);
      setDropSuggestions([]);
    }
  });
};

const handlecreatetrip = (formValues) => {

  formValues.bookingType="HOTEL";
    formValues.tripType = "HOTEL";
    formValues.payment_mode = "HOTEL";   
  formValues.d_address=dropInput;
  formValues.d_latitude=dropLatLng.lat;
  formValues.d_longitude=dropLatLng.lng;
  formValues.distance=distance;
  formValues.minutes=travelDuration;
  formValues.s_address=pickupInput;
  formValues.s_latitude=pickupLatLng.lat;
  formValues.s_longitude=pickupLatLng.lng;
  formValues.service_type=activeService?.service_id;
  formValues.estimatedFare=activeService?.estimated_fare;
  formValues.userType=userType;

  console.log('formValues-->',formValues);

    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Ride created successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        navigate('/upcomingtrips_hotel');
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating ride",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      formik.resetForm();
      const pickupInput = document.getElementById("pickuplocation");
      const dropInput = document.getElementById("droplocation");
    
      if (pickupInput) {
        pickupInput.value = ""; 
        setPickupInput("");
      }
    
      if (dropInput) {
        dropInput.value = ""; 
        setDropInput("");// Clear the value of the drop location field
      }
    };
    HotelApi.createridebyhotel({ ...formValues }).then(onSuccess, onFailure);
};

   const formik = useFormik({
    initialValues: {
      guest_name: "",
      service_type: "",
      s_latitude:"",
      s_longitude:"",
      s_address:"",
      d_latitude:"",
      d_longitude:"",
      d_address:"",
      distance:"",
      minutes:"",
      bookingType:"",
      userNotes:"",
    },
    validationSchema: yup.object({
      guest_name: yup.string().required("First Name is required").nullable(),
       s_address: yup
        .string()
        .required("Pickup Location is required")
        .nullable(),
      d_address: yup
        .string()
        .required("Drop Location is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlecreatetrip(values); // Ensure this processes `values` correctly
    },
    });

  return (
<>
        <Grid item xs={12} md={4} sx={{ p:1, overflowY: "auto" }}>
<Box className={classes.bookingformbox}>

<div className={classes.booking_header} >

<Typography variant="h5" component="h2">
New Booking
</Typography>

</div>
<div id="map-temp" style={{ display: 'none' }}></div>
<div className={classes.autocomplete_control}>

<Box sx={{ display: "flex", flexDirection: "column", gap: 1, position: "relative", width: "100%" }}>

{/* Pickup Location */}

<Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
<LocationOn sx={{ color: "green", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }} />
  <TextField
    id="pickuplocation"
    label="Pickup Location"
    variant="outlined"
    size="small"
    value={pickupInput}
    onChange={(e) => {
    handlePickupChange(e); 
    formik.setFieldValue("s_address", e.target.value); // sync with Formik
  }}
  error={Boolean(formik.touched.s_address && formik.errors.s_address)}
  helperText={formik.touched.s_address && formik.errors.s_address}
    className={classes.autocomplete_inputs}
  />

  <Box
  sx={{
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    zIndex: 5,
    background: "#fff",
    boxShadow: 3,
    maxHeight: 200, // Limit height
    overflowY: "auto", // Enable scrolling
  }}
>    {pickupSuggestions.map((suggestion) => (
      <Box
        key={suggestion.place_id}
        sx={{ padding: 1, cursor: "pointer", '&:hover': { backgroundColor: "#eee" } }}
        onClick={() => handlePickupSelect(suggestion.place_id, suggestion.description)}
      >
        {suggestion.description}
      </Box>
    ))}
  </Box>
</Box>

{/* Dotted Line */}
<Box sx={{ height: 20, width: 2, background: "gray", marginLeft: "18px", opacity: 0.5, borderLeft: "2px dotted gray" }} />

{/* Drop Location */}

<Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
<LocationOn sx={{ color: "red", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }} />

<TextField
id="drop"
label="Drop Location"
variant="outlined"
size="small"
value={dropInput}
onChange={(e) => {
    handleDropChange(e); 
    formik.setFieldValue("d_address", e.target.value);
  }}
  error={Boolean(formik.touched.d_address && formik.errors.d_address)}
  helperText={formik.touched.d_address && formik.errors.d_address}
className={classes.autocomplete_inputs}
/>

  <Box
  sx={{
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    zIndex: 5,
    background: "#fff",
    boxShadow: 3,
    maxHeight: 200, // Limit height
    overflowY: "auto", // Enable scrolling
  }}
>   {dropSuggestions.map((suggestion) => (
    <Box
      key={suggestion.place_id}
      sx={{ padding: 1, cursor: "pointer", '&:hover': { backgroundColor: "#eee" } }}
      onClick={() => handleDropSelect(suggestion.place_id, suggestion.description)}
    >
      {suggestion.description}
    </Box>
  ))}
</Box>
</Box>


</Box>

<Grid container rowSpacing={1} className={classes.containerformik} >

<Grid item xs={6} className={classes.formikgrids} >
 <TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="guest_name"
    label="Guest Name"
    value={formik?.values?.guest_name}
    defaultValue={formik?.values?.guest_name}
    onChange={formik.handleChange}
    error={
      formik?.errors?.guest_name &&
      formik?.touched?.guest_name
    }
    helperText={
      formik?.errors?.guest_name &&
      formik?.touched?.guest_name &&
      formik?.errors?.guest_name
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>

<Grid item xs={6} className={classes.formikgrids} >
 <TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="userNotes"
    label="Driver Notes"
    value={formik?.values?.userNotes}
    defaultValue={formik?.values?.userNotes}
    onChange={formik.handleChange}
    error={
      formik?.errors?.userNotes &&
      formik?.touched?.userNotes
    }
    helperText={
      formik?.errors?.userNotes &&
      formik?.touched?.userNotes &&
      formik?.errors?.userNotes
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>

</Grid>

</div>

{/* distance and duration */}

<DistanceAndRate 
pickupLatLng={pickupLatLng} dropLatLng={dropLatLng} 
origin={origin} destination={destination} distance={distance} duration={duration}
setMapCenter={setMapCenter} setDistance={setDistance} setDuration={setDuration}
 />

{/* Estimated carousel */}

<Estimatedcarousel distance={distance} duration={duration} services={services} 
setTravelduration={setTravelduration} timezone={timezone} setActiveService={setActiveService}/>

          {/* Buttons */}
<Grid item xs={12} className={classes.switchWrapper} >
<Button variant="contained" onClick={formik?.handleSubmit}>
Book Now
</Button>
</Grid>

</Box>
</Grid>
</>
  );
};

export default BookingForm;
